// a list of tokens by chain
import { Currency, Token } from '@kodiak-finance/sdk-core'
import { SupportedChainId } from 'config/chains'

import {
  BUSD_BEPOLIA,
  BUSD_BERA,
  nativeOnChain,
  SPY_ROBINHOOD,
  USDC_BERA,
  USDG_ROBINHOOD,
  USDT_BERA,
  WBTC_BERA,
  WETH_BERA,
  WRAPPED_NATIVE_CURRENCY,
} from './tokens'

type ChainCurrencyList = {
  readonly [chainId: number]: Currency[]
}

/**
 * Shows up in the currency select for swap and add liquidity
 */
export const COMMON_BASES: ChainCurrencyList = {
  [SupportedChainId.BEPOLIA]: [
    nativeOnChain(SupportedChainId.BEPOLIA),
    WRAPPED_NATIVE_CURRENCY[SupportedChainId.BEPOLIA] as Token,
    BUSD_BEPOLIA,
  ],

  [SupportedChainId.BERA]: [
    nativeOnChain(SupportedChainId.BERA),
    WRAPPED_NATIVE_CURRENCY[SupportedChainId.BERA] as Token,
    BUSD_BERA,
    WETH_BERA,
    WBTC_BERA,
    USDC_BERA,
    USDT_BERA,
  ],

  [SupportedChainId.ROBINHOOD]: [
    nativeOnChain(SupportedChainId.ROBINHOOD),
    WRAPPED_NATIVE_CURRENCY[SupportedChainId.ROBINHOOD] as Token,
    USDG_ROBINHOOD,
    SPY_ROBINHOOD,
  ],
}
